module.exports = __webpack_public_path__ + "static/img/emoji_1.fb2361af.png";